// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"37b78fb0","2851":"37b78fb0","2998":"37b78fb0","8589":"3b53517f","8688":"7fe95281"}[chunkId] + ".chunk.css";
};